import React from 'react'
import '../styles/sidedrawer.css'


const SideDrawer = props => {
    return (
        <nav className='side__drawer'>
            <button type="button" class="close" aria-label="Close" onClick={props.toggleDrawer}>
                <span aria-hidden="true">&times;</span>
            </button>
            <ul>
                <li><a href='https://activebuildings.in' > HOME </a></li>
                <li><a href='https://activebuildings.in/solutions'> SOLUTIONS </a></li>
                <li><a href='https://activebuildings.in/case' > CASE STUDIES </a></li>
                <li><a href='https://activebuildings.in/about'> ABOUT US </a></li>
                <li><a href='https://activebuildings.in/contact'> CONTACT US </a></li>
                <li><a href='/'> BLOG </a></li>
                <li><a href='https://dashboard.activebuildings.in/login'> LOGIN </a></li>
            </ul>
        </nav>


    )
}

export default SideDrawer